//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'

export default {
  name: 'GoutClassificationCriteria',
  data () {
    return {
      form: {
        patterns: '',
        characteristic: '',
        process: '',
        gout: '',
        serum: '',
        synovial: '',
        Radiographic: '',
        evidence: ''
      },
      defaultJson: {
        'Patterns of joint/bursal involvement during seizures': '发作期间关节/滑囊受累的模式',
        'Characteristic categories of seizures': '发作的特征类别',
        'Seizure process class': '发作进程类别',
        'Gout calculus': '痛风结石',
        'Serum urate level': '血清尿酸盐水平',
        'Synovial analysis': '滑液分析',
        'Radiographic findings of urate deposition': '尿酸盐沉积的影像学结果',
        'Imaging evidence of joint injury associated with gout': '痛风相关关节损伤的影像学证据'
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        {value: '0', name: '除踝关节、中足关节或第一髁趾关节（MTP）外的其他关节或滑囊'},
        {value: '1', name: '踝关节或中足关节为单发或少关节发作的一部分，无MTP受累'},
        {value: '2', name: 'MTP受累为单发或少关节发作的一部分'}
      ],
      dataList2: [
        {value: '0', name: '无'},
        {value: '1', name: '1个特征'},
        {value: '2', name: '2个特征'},
        {value: '3', name: '3个特征'}
      ],
      dataList3: [
        {value: '0', name: '无典型发作'},
        {value: '1', name: '1个典型发作'},
        {value: '2', name: '复发典型发作'},
      ],
      dataList4: [
        {value: '0', name: '不存在'},
        {value: '4', name: '存在'}
      ],
      dataList5: [
        {value: '-4', name: '<4mg/dL（0.24mmol/L）'},
        {value: '0', name: '4~6mg/dL（0.24~0.36mmol/L）'},
        {value: '2', name: '6~8mg/dL（0.36~0.48mmol/L）'},
        {value: '3', name: '8~10mg/dL（0.48~0.6mmol/L）'},
        {value: '4', name: '≥10mg/dL（≥0.6mmol/L）'}
      ],
      dataList6: [
        {value: '-2', name: '滑液为MSU阴性'},
        {value: '0', name: '没有MSU结果'}
      ],
      dataList7: [
        {value: '0', name: '没有成像（即放射学、超声或DECT成像）结果'},
        {value: '4', name: '存在'}
      ],
      dataList8: [
        {value: '0', name: '没有成像（即放射学、超声或DECT成像）结果'},
        {value: '4', name: '存在'}
      ]
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '...'
      } else {
        let result = form.patterns + form.characteristic + form.process + form.gout + form.serum + form.synovial + form.Radiographic + form.evidence
        self.hasScore = true
        return String(result)
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/formulas/RI/GoutClassificationCriteria.vue